import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import querystring from "query-string";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import store from "./Store/store";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const root = createRoot(document.getElementById("root"));
const queryParams = querystring.parse(window.location.search);
const THEME = createTheme({
  typography: {
    fontFamily: `"Verdana", "Tahoma", "Arial" !important`,
    fontSize: 12,
  },
});

// Global handler for legacy popup integration.
// Expected usage from popup:
//   window.parent.onSelectCatKeyValues(catID, sKey1, sKey2, sKey3);
// Returns false and dispatches 'catalogue:select' with { catId, sKey1, sKey2, sKey3 }.
if (typeof window !== "undefined") {
  if (typeof window.onSelectCatKeyValues !== "function") {
    window.onSelectCatKeyValues = function (catId, sKey1, sKey2, sKey3) {
      try {
        const detail = { catId, sKey1, sKey2, sKey3 };
        window.dispatchEvent(new CustomEvent("catalogue:select", { detail }));
      } catch (e) {
        console.error("onSelectCatKeyValues error:", e);
      }
      // Return false to align with legacy handlers that close popups
      return false;
    };
  }
}
root.render(
  <ThemeProvider theme={THEME}>
    <Provider store={store}>
      <App queryParams={queryParams} />
    </Provider>
  </ThemeProvider>
);
